import { ref, get, set } from "firebase/database";
import db from "./firebase";

export const getDailyVisits = async () => {
    const porDiaRef = ref(db, 'hi-blinds/visitasPorDia');
    const diaSnap = await get(porDiaRef);
    const data = diaSnap.exists() ? diaSnap.val() : {};
  
    const hoy = new Date();
    const fechaLimite = new Date();
    fechaLimite.setDate(hoy.getDate() - 29);
  
    const lista = Object.entries(data)
      .map(([fecha, visitas]) => ({
        fecha,
        visitas,
      }))
      .filter(item => new Date(item.fecha) >= fechaLimite)
      .sort((a, b) => new Date(a.fecha) - new Date(b.fecha));
  
    return lista;
  };
const getFechaActual = () => {
  const hoy = new Date();
  return hoy.toISOString().split("T")[0]; 
};

export const incrementVisit = async () => {
  const ultimaVisita = localStorage.getItem("ultimaVisitaHiBlinds");

  const ahora = Date.now();
  const unaHora = 60 * 60 * 1000;

  if (!ultimaVisita || ahora - parseInt(ultimaVisita) > unaHora) {
    const totalRef = ref(db, 'hi-blinds/visitasTotales');
    const porDiaRef = ref(db, 'hi-blinds/visitasPorDia');
    const fecha = new Date().toISOString().split("T")[0];

    const totalSnap = await get(totalRef);
    const totalActual = totalSnap.exists() ? totalSnap.val() : 0;
    await set(totalRef, totalActual + 1);

    const diaSnap = await get(porDiaRef);
    const dataPorDia = diaSnap.exists() ? diaSnap.val() : {};
    const visitasHoy = dataPorDia[fecha] || 0;
    dataPorDia[fecha] = visitasHoy + 1;
    await set(porDiaRef, dataPorDia);

    localStorage.setItem("ultimaVisitaHiBlinds", ahora.toString());
  }
};

export const getVisitStats = async () => {
  const totalRef = ref(db, 'hi-blinds/visitasTotales');
  const porDiaRef = ref(db, 'hi-blinds/visitasPorDia');
  const fecha = getFechaActual();

  const [totalSnap, diaSnap] = await Promise.all([
    get(totalRef),
    get(porDiaRef)
  ]);

  const total = totalSnap.exists() ? totalSnap.val() : 0;
  const porDia = diaSnap.exists() ? diaSnap.val() : {};
  const hoy = porDia[fecha] || 0;


  const ahora = new Date();
  const semanaFechas = [...Array(7)].map((_, i) => {
    const d = new Date(ahora);
    d.setDate(d.getDate() - i);
    return d.toISOString().split("T")[0];
  });

  const semana = semanaFechas.reduce((acc, fecha) => acc + (porDia[fecha] || 0), 0);

  return { total, hoy, semana };
};